/**
 * @generated SignedSource<<f47d865d297fa3e9c9da5fba2184a8c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleAuthorBlockArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "entityFollowButtonBase">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"articleDateContent" | "authorNamesArticle">;
  readonly " $fragmentType": "articleAuthorBlockArticle";
};
export type articleAuthorBlockArticle$key = {
  readonly " $data"?: articleAuthorBlockArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleAuthorBlockArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleAuthorBlockArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleDateContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNamesArticle"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityFollowButtonBase"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "authorAvatarAuthor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a854f79e04642989198b893c715b7f4f";

export default node;
